import script from "./CustomerDocumentation.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerDocumentation.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__